// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Dice Game – Vertical mobile-first layout
 * Works with cm-* design system from Flappy.css
 */

/* ── Dice arena (central play area) ── */
.dice-arena {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  min-height: 0;
  background: rgba(0,0,0,0.15);
}

.dice-arena__status {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
  color: rgba(255,255,255,0.7);
  font-size: 14px;
}

.dice-arena__spinner {
  font-size: 64px;
  animation: dice-spin 3s linear infinite;
}

@keyframes dice-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.dice-arena__versus {
  display: flex;
  align-items: center;
  gap: 24px;
}

.dice-arena__col {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.dice-arena__label {
  font-size: 13px;
  font-weight: 600;
  color: rgba(255,255,255,0.6);
}

.dice-arena__vs {
  font-size: 18px;
  font-weight: 800;
  color: rgba(255,255,255,0.3);
}

/* ── Dice roll value display ── */
.dice-roll-value {
  font-family: 'SF Mono', 'Fira Code', 'Consolas', monospace;
  font-weight: 800;
  font-size: 22px;
  background: rgba(255,255,255,0.08);
  color: #fbbf24;
  padding: 4px 12px;
  border-radius: 8px;
  min-width: 40px;
  text-align: center;
}

.dice-roll-value--big {
  font-size: 56px;
  padding: 14px 28px;
  border-radius: 14px;
  background: rgba(255,255,255,0.06);
  border: 2px solid rgba(251,191,36,0.25);
}

/* ── Roll button (larger for dice) ── */
.dice-roll-btn {
  padding: 14px 40px !important;
  font-size: 16px !important;
  letter-spacing: 0.5px;
}

/* ── Series score in player bar ── */
.dice-series-score {
  font-family: 'SF Mono', 'Fira Code', 'Consolas', monospace;
  font-weight: 800;
  font-size: 24px;
  color: #fbbf24;
  min-width: 32px;
  text-align: center;
}

/* ── Legacy classes kept for backwards compat ── */
.game-container { min-height: 100vh; }
.challenge-game-container { min-height: 100vh; }
`, "",{"version":3,"sources":["webpack://./src/styles/Game.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,yCAAyC;AACzC;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,kCAAkC;AAClC;EACE,0DAA0D;EAC1D,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA,wCAAwC;AACxC;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA,qCAAqC;AACrC;EACE,0DAA0D;EAC1D,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,mDAAmD;AACnD,kBAAkB,iBAAiB,EAAE;AACrC,4BAA4B,iBAAiB,EAAE","sourcesContent":["/**\n * Dice Game – Vertical mobile-first layout\n * Works with cm-* design system from Flappy.css\n */\n\n/* ── Dice arena (central play area) ── */\n.dice-arena {\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  min-height: 0;\n  background: rgba(0,0,0,0.15);\n}\n\n.dice-arena__status {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  text-align: center;\n  color: rgba(255,255,255,0.7);\n  font-size: 14px;\n}\n\n.dice-arena__spinner {\n  font-size: 64px;\n  animation: dice-spin 3s linear infinite;\n}\n\n@keyframes dice-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.dice-arena__versus {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.dice-arena__col {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.dice-arena__label {\n  font-size: 13px;\n  font-weight: 600;\n  color: rgba(255,255,255,0.6);\n}\n\n.dice-arena__vs {\n  font-size: 18px;\n  font-weight: 800;\n  color: rgba(255,255,255,0.3);\n}\n\n/* ── Dice roll value display ── */\n.dice-roll-value {\n  font-family: 'SF Mono', 'Fira Code', 'Consolas', monospace;\n  font-weight: 800;\n  font-size: 22px;\n  background: rgba(255,255,255,0.08);\n  color: #fbbf24;\n  padding: 4px 12px;\n  border-radius: 8px;\n  min-width: 40px;\n  text-align: center;\n}\n\n.dice-roll-value--big {\n  font-size: 56px;\n  padding: 14px 28px;\n  border-radius: 14px;\n  background: rgba(255,255,255,0.06);\n  border: 2px solid rgba(251,191,36,0.25);\n}\n\n/* ── Roll button (larger for dice) ── */\n.dice-roll-btn {\n  padding: 14px 40px !important;\n  font-size: 16px !important;\n  letter-spacing: 0.5px;\n}\n\n/* ── Series score in player bar ── */\n.dice-series-score {\n  font-family: 'SF Mono', 'Fira Code', 'Consolas', monospace;\n  font-weight: 800;\n  font-size: 24px;\n  color: #fbbf24;\n  min-width: 32px;\n  text-align: center;\n}\n\n/* ── Legacy classes kept for backwards compat ── */\n.game-container { min-height: 100vh; }\n.challenge-game-container { min-height: 100vh; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
